import React from 'react'
import { TranslationProvider } from '../shared/TranslationProvider'
import translations from './locales.json'
import { ExerciseProvider, useExercise } from './ExerciseProvider'
import Exercise from './Exercise'
import StartExercise from './StartExercise'
import Conclusion from './Conclusion'
import NetworkingPreferencesConclusion from './NetworkingPreferences/NetworkingPreferencesConclusion'
import SocialMediaConclusion from './SocialMediaReview/SocialMediaConclusion'
import RetirementGoalsConclusion from './RetirementGoals/RetirementGoalsConclusion'
import LinkedinVisibilitySelfAuditConclusion from './LinkedinVisibilitySelfAudit/LinkedinVisibilitySelfAuditConclusion'
import TaskCompletedModal from '../shared/TaskCompletedModal'

const Index = ({ ...props }) => {
  return (
    <ExerciseProvider {...props}>
      <ExerciseComponents {...props} />
    </ExerciseProvider>
  )
}

export default Index

const ExerciseComponents = ({ locale }) => {
  const {
    documentId,
    started,
    showConclusion,
    exerciseName,
    embedExercise,
    inActionPlan,
  } = useExercise()

  return (
    <TranslationProvider
      locale={locale || 'en'}
      translations={translations}
      scope={'javascript.components.Exercises'}
    >
      {exerciseName === 'Networking Preferences' && showConclusion ? (
        <NetworkingPreferencesConclusion />
      ) : exerciseName === 'Social Media Review' && showConclusion ? (
        <SocialMediaConclusion />
      ) : exerciseName === 'Linkedin Visibility Self Audit' &&
        showConclusion ? (
        <LinkedinVisibilitySelfAuditConclusion />
      ) : exerciseName === 'Retirement Goals' && showConclusion ? (
        <RetirementGoalsConclusion />
      ) : (
        showConclusion && <Conclusion />
      )}
      {showConclusion && inActionPlan && (
        <TaskCompletedModal open={true} isExercise={true} locale={locale} />
      )}
      {!embedExercise && !started && !showConclusion && (
        <StartExercise exerciseExists={!!documentId} />
      )}
      {(started || embedExercise) && !showConclusion && <Exercise />}
    </TranslationProvider>
  )
}
